<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.full_name" id="profileDropdown">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.full_name }}</p>
      <small>IP Simulations</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-4">
       <!--- <img v-if="activeUserInfo.profile_picture" key="onlineImg" :src="activeUserInfo.profile_picture" alt="user-img" width="40" height="40" class="rounded shadow-md cursor-pointer block" /> --->
        <img key="onlineImg" :src="'https://portal-cdn.rapid.education/profile-pictures/default.jpeg'" alt="user-img" width="40" height="40" class="rounded shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="themeToggleSettings = !themeToggleSettings">
            <feather-icon icon="SunIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Theme</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$fullscreen.toggle()">
            <feather-icon icon="Maximize2Icon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Full Screen</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="audioToggleSettings = !audioToggleSettings">
            <feather-icon icon="MusicIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Audio</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Logout</span>
          </li>

        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <vs-popup :active.sync="audioToggleSettings" title="Audio Settings">
      <div class="p-2">
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <div class="flex items-center justify-center">
              <lottie-animation
                path="https://assets7.lottiefiles.com/packages/lf20_tyi61jpp.json"
                :loop="true"
                :autoPlay="true"
                :speed="1"
              />
            </div>
          </div>
          <div class="vx-col w-1/2">
            <h1>Audio Settings</h1>

            <div class="mt-5 flex p-3 rounded-lg" style="background: #050056" @click="updateAudioSettings({'backgroundMusic': !audioSettings.backgroundMusic})">
              <vs-switch color="success" v-model="audioSettings.backgroundMusic" class="mr-3" @click.prevent/>
              <h4>Background Music</h4>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup :active.sync="themeToggleSettings" title="Change Theme">
      <div class="vx-row mb-2">
        <div class="vx-col w-1/3 text-black cursor-not-allowed">
          <!--- @click="toggleTheme('light')" :class="currentTheme === 'light' ? 'border-success' : 'border-none'" --->
          <div class="border border-solid m-3 p-6 rounded bg-white"
               @click="$vs.notify({color: 'danger', title: 'Choose Another Theme', text: 'Bright Mode Has Been Discontinued', position: 'top-right',  iconPack: 'feather',icon: 'icon-alert-circle',})"
               style="background-color: #F2F2F2" >
            <div class="flex items-center justify-center">
              <feather-icon icon="SunIcon" svgClasses="h-16 w-16"/>
            </div>
            <h2 class="text-center text-black mt-4">Bright</h2>
          </div>
        </div>
        <div class="vx-col w-1/3 hover:text-primary text-white cursor-pointer">
          <vs-tooltip text="Light Mode No Longer Supported">
            <div class="border border-solid m-3 p-6 rounded" style="background-color: #050056" @click="toggleTheme('midnight')" :class="currentTheme === 'midnight' ? 'border-success' : 'border-none'">
              <div class="flex items-center justify-center">
                <feather-icon icon="CloudIcon" svgClasses="h-16 w-16"/>
              </div>
              <h2 class="text-center mt-4 text-white">Midnight</h2>
            </div>
          </vs-tooltip>
        </div>
        <div class="vx-col w-1/3 hover:text-primary text-white cursor-pointer">
          <div class="border border-solid m-3 p-6 rounded" style="background-color: #1B1E22" @click="toggleTheme('dark')" :class="currentTheme === 'dark' ? 'border-success' : 'border-none'">
            <div class="flex items-center justify-center">
              <feather-icon icon="MoonIcon" svgClasses="h-16 w-16"/>
            </div>
            <h2 class="text-center mt-4 text-white">Dark</h2>
          </div>
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import LottieAnimation from '@/components/lottie/LottieAnimation'

export default {
  data () {
    return {
      audioToggleSettings: false,
      themeToggleSettings: false
    }
  },
  computed: {
    audioSettings () {
      return this.$store.state.AudioSettings
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    currentTheme () {
      return this.$store.state.theme
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userInfo')
      this.$router.push('/login')
    },
    toggleTheme (color) {
      if (color === 'dark' || color === 'light' || color === 'midnight') {
        localStorage.setItem('selectedTheme', color)
        location.reload()
      }
    },
    updateAudioSettings (pl) {
      this.$store.commit('UPDATE_AUDIO_SETTINGS', pl, {root: true})
    }
  },
  components: {
    LottieAnimation
  }
}
</script>
<style lang="scss">
</style>
